import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { ImageEditorComponent, OpenEventArgs, ImageEditorModule } from '@syncfusion/ej2-angular-image-editor';
import { ClickEventArgs } from '@syncfusion/ej2-angular-navigations';
import { NgClass } from '@angular/common';

@Component({
    selector: 'app-asset-image-editor',
    templateUrl: './asset-image-editor.component.html',
    styleUrls: ['./asset-image-editor.component.scss'],
    imports: [NgClass, ImageEditorModule]
})
export class AssetImageEditorComponent {
  @Input()
  set fileData(value: string | Blob) {
    if (value !== this._fileData) {
      this._fileData = value;
      if (this._fileData instanceof Blob) {
        this.openBlob(this._fileData);
      } else if (typeof this._fileData === 'string' && this._fileData.length > 0) {
        this.imageEditorObj?.open(this._fileData);
      } else {
        this.imageEditorObj?.reset();
      }
      this._changeCount = 0;
    }
  }

  @Input()
  set fullScreen(value: boolean) {
    this.isFullScreen = value;
    setTimeout(() => {
      this.imageEditorObj?.update();
    }, 0);
  }

  @Output()
  public fileOpened: EventEmitter<OpenEventArgs> = new EventEmitter<OpenEventArgs>();

  public isFullScreen: boolean = false;

  @ViewChild('imageEditor')
  public imageEditorObj: ImageEditorComponent;

  private _fileData: string | Blob;
  private _changeCount = 0;

  public reset(): void {
    setTimeout(() => { this.imageEditorObj?.update(); this.imageEditorObj?.reset(); this._changeCount = 0 }, 0);
  }

  public hasPendingChanges(): boolean {
    // https://stackoverflow.com/questions/8714090/how-to-do-a-wildcard-element-name-match-with-queryselector-or-queryselector
    var okElem = document.querySelector("[id^='ej2-image-editor_'][id$='_ok']");
    return (okElem) ? true : false;
  }

  public hasBeenEdited(): boolean {
    return this._changeCount > 0;
  }

  public created(): void {
    if (this._fileData instanceof Blob) {
      this.openBlob(this._fileData);
    } else {
      this.imageEditorObj?.open(this._fileData);
    }
    this._changeCount = 0;
  }

  public onToolbarItemClicked(args: ClickEventArgs) {
    if (args.item.id?.endsWith('_ok')) {
      this._changeCount++;
    } else if (args.item.id?.endsWith('_undo')) {
      this._changeCount--;
    } else if (args.item.id?.endsWith('_reset')) {
      this._changeCount = 0;
    } else if (args.item.id?.endsWith('_redo')) {
      this._changeCount++;
    }
  }

  public onFileOpened(args: OpenEventArgs) {
    this.fileOpened.emit(args);
  }

  private openBlob(blob: Blob): void {
    const reader = new FileReader();
    reader.onload = () => {
      const dataUrl = reader.result as string;
      this.imageEditorObj?.open(dataUrl);
    };
    reader.readAsDataURL(blob);
  }
}
